import { render, staticRenderFns } from "./InShop.vue?vue&type=template&id=2b2a7190&"
import script from "./InShop.vue?vue&type=script&lang=js&"
export * from "./InShop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports